import { render, staticRenderFns } from "./ReviewExecutor.vue?vue&type=template&id=bb245dee&scoped=true&"
import script from "./ReviewExecutor.vue?vue&type=script&lang=ts&"
export * from "./ReviewExecutor.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewExecutor.vue?vue&type=style&index=0&id=bb245dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb245dee",
  null
  
)

export default component.exports